import { Typography, colors } from "@mui/material";

import { Box } from "@mui/system";
import { Person } from "@mui/icons-material";
import { primary } from "theme/colors";
import { regular } from "constants/space";
import styled from "styled-components";

export const Bubble = styled(Box)`
  background-color: ${primary}22;
  padding: 10px;
  max-width: 40vw;
  min-width: 20vw;
  overflow-wrap: break-word;
  border-radius: ${regular}px ${regular}px 0px ${regular}px;
`;

export const BubbleName = styled(Typography).attrs({
  variant: "subtitle2",
})`
  color: ${colors.grey[700]};
`;

export const BubbleTime = styled(Typography).attrs({
  variable: "subtitle2",
})`
  font-size: 0.8rem !important;
  color: ${colors.grey["600"]};
`;

export const BubbleMessage = styled(Typography)`
  margin-top: 10px !important;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const AgentIcon = styled(Person)`
  color: white;
  background-color: ${primary};
  padding: 2px;
  margin-right: 10px;
  border-radius: 20px;
`;
